module.exports = __webpack_public_path__ + "static/media/zoomOut-light.b35a37a2.svg";